import { render } from "./PageDetailSecteur.vue?vue&type=template&id=047b4f81&scoped=true"
import script from "./PageDetailSecteur.vue?vue&type=script&lang=js"
export * from "./PageDetailSecteur.vue?vue&type=script&lang=js"

import "./PageDetailSecteur.vue?vue&type=style&index=0&id=047b4f81&scoped=true&lang=sass"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047b4f81"]])

export default __exports__